// extracted by mini-css-extract-plugin
var _1 = "ra-grid-view-switch-active";
var _2 = "ra-grid-view-switch";
var _3 = "ra-grid-view-switch-item";
var _4 = "ra-grid-view-switch-label";
export { _1 as "viewSwitchActiveCls", _2 as "viewSwitchCls", _3 as "viewSwitchItemCls", _4 as "viewSwitchLabelCls" }
